export default __webpack_public_path__ + "static/3nd Duovocal-9d27a9e44ec2cd612a127748fa85d499.webm";